<template>
  <section
    class="bg-newsletter"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3>STAY UPDATED</h3>
        </div>
        <div class="col-md-6 col-12">
          <p class="subheading">
            Sign up for the Art Grab newsletter to hear about new artwork and
            updates from the Art Grab team.
          </p>
          <small
            >We respect your privacy and will never sell, rent, lease or give
            away your information (name, address, email, etc.) to any third
            party.</small
          >
        </div>
        <div class="col-md-6 col-12 email-wrapper">
          <form
            action="https://artgrab.us20.list-manage.com/subscribe/post?u=ce212b8756256b2fd94b6d38e&amp;id=d4b90ce745"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <input
              type="email"
              value
              v-model="email"
              name="EMAIL"
              class="form-control"
              id="mce-EMAIL"
              placeholder="Enter your email address"
              required
              spellcheck="false"
            />
            <!-- Real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px" aria-hidden="true">
              <input
                type="text"
                name="b_fccbe07f98e70416a52aa53ee_09ed0eae3b"
                tabindex="-1"
                value
              />
            </div>

            <input
              type="submit"
              value="SIGN UP NOW"
              name="subscribe"
              id="mc-embedded-subscribe"
              class="btn btn-block bg-gradient-info signup-button"
            />
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "newsletter-signup",
  data() {
    return {
      email: "",
    };
  },
  props: {
    bgImage: {
      type: String,
      description: "Header background image",
    },
  },
};
</script>

<style lang="scss">
.bg-newsletter {
  background-size: cover;
  background-position: center;
  background-color: black;
  color: white;
  padding: 10rem 0;

  .form-group {
    margin-bottom: 1.2rem;
  }

  .signup-button {
    margin-top: 1.2rem;
    color: white;
  }

  .form-control {
    margin-top: 0.5rem;
    background: rgba(255, 255, 255, 0.2) !important;
    color: white;
    &::placeholder {
      color: white;
    }

    &:focus {
      border-color: #11cdef;
    }
  }

  .subheading {
    font-size: 1.125rem;
    font-weight: 700;
    margin-bottom: 10px;
  }

  h3 {
    color: white;
    font-size: 2.25rem;
  }
}

@media (max-width: 575.98px) {
  .bg-newsletter {
    padding: 5rem 0;
    text-align: center;

    h3 {
      font-size: 1.8rem;
    }

    .subheading {
      font-size: 1rem;
      padding: 0 1.5rem;
      margin-top: 1rem;
    }

    small {
      padding: 0 1.5rem;
      display: block;
      margin-bottom: 1.5rem;
    }

    .email-wrapper {
      padding: 0 2rem;
    }
  }
}
</style>
